export const buildWorkOrderStatusFields = ({
  newWorkOrder,
  editingId,
  scheduleDisabled = false,
  startDisabled = false,
  completeDisabled = false,
  includeTeams = true,
  formatOptionColor,
  includeCrew = false,
  crewOptions = [],
  crewDisabled = false,
  includeWorkOrderImages = false,
  handleImageClick,
}) => {
  const fields = [];

  if (newWorkOrder.statusId === 2) {
    fields.push(
      {
        field: 'startedAt',
        label: 'Started',
        type: 'datetime',
        size: 4,
        required: true,
        disabled: startDisabled,
      }, {
      field: 'dueDate',
      label: 'Estimated Completion',
      type: 'datetime',
      size: 4,
      required: true,
      displayField: '',
      disabled: scheduleDisabled,
    });
    if (includeTeams) {
      fields.push({
        field: 'teamsId',
        label: 'Assigned Team',
        type: 'select',
        size: 4,
        required: false,
        api: 'teams',
        displayField: 'teamName',
        isClearable: true,
        formatOptionLabel: formatOptionColor,
      });
    }
  } else if (newWorkOrder.statusId !== 4) {
    fields.push(
      {
        field: 'scheduledAt',
        label: 'Scheduled Start',
        type: 'datetime',
        size: 4,
        required: false,
        displayField: '',
        disabled: scheduleDisabled,
      },
      {
        field: 'dueDate',
        label: 'Scheduled End',
        type: 'datetime',
        size: 4,
        required: false,
        displayField: '',
        disabled: scheduleDisabled,
      },
    );
    if (includeTeams) {
      fields.push({
        field: 'teamsId',
        label: 'Assigned Team',
        type: 'select',
        size: 4,
        required: false,
        api: 'teams',
        displayField: 'teamName',
        isClearable: true,
        formatOptionLabel: formatOptionColor,
      });
    }
  }

  if (newWorkOrder.statusId === 4) {
    fields.push(
      {
        field: 'startedAt',
        label: 'Started',
        type: 'datetime',
        size: 4,
        required: true,
        disabled: startDisabled,
      },
      { field: '__actualDuration', label: 'Actual Duration', type: 'custom', size: 4 },
      {
        field: 'completedAt',
        label: 'Completed',
        type: 'datetime',
        size: 4,
        required: true,
        disabled: completeDisabled,
      },
      {
        field: 'teamsId',
        label: 'Assigned Team',
        type: 'select',
        size: 4,
        required: false,
        api: 'teams',
        displayField: 'teamName',
        isClearable: true,
        formatOptionLabel: formatOptionColor,
      }
    );
  } else {
    const includeStartedField = editingId
      ? newWorkOrder.statusId !== 1
      : [2, 3, 4].includes(newWorkOrder.statusId);
    const includeCompletedField = editingId
      ? ![1, 2].includes(newWorkOrder.statusId)
      : [3, 4].includes(newWorkOrder.statusId);

    /* if (includeStartedField) {
      fields.push({
        field: 'startedAt',
        label: 'Started',
        type: 'datetime',
        size: 4,
        required: newWorkOrder.statusId === 4 ? true : [2, 3].includes(newWorkOrder.statusId),
        disabled: startDisabled,
      });
    } */

    if (includeCompletedField) {
      fields.push({
        field: 'completedAt',
        label: 'Completed',
        type: 'datetime',
        size: 4,
        required: newWorkOrder.statusId === 4 ? true : newWorkOrder.statusId === 3,
        disabled: completeDisabled,
      });
    }
  }

  if (includeCrew) {
    fields.push({
      field: 'crew',
      label: 'Assigned Crew',
      type: 'multi-select',
      size: 12,
      required: false,
      options: crewOptions,
      disabled: crewDisabled,
    });
  }

  if (includeWorkOrderImages && newWorkOrder.statusId === 1) {
    fields.push({
      field: 'workOrderImage',
      label: 'Images',
      type: 'images',
      size: 12,
      directory: 'workorderimages',
      onImageClick: handleImageClick,
    });
  }

  return fields;
};

export const buildWorkOrderCompleteFields = ({
  newWorkOrder,
  handleImageClick,
  includeCompletionImages = true,
}) => {
  const fields = [
    { field: 'failureId', label: 'Failure', type: 'select', size: 4, required: false, api: 'failure-codes', displayField: 'name' },
    { field: 'causeId', label: 'Cause', type: 'select', size: 4, required: false, api: 'cause-codes', displayField: 'name' },
    { field: 'symptom', label: 'Symptom', type: 'textarea', lines: 1, size: 12, required: false },
    { field: 'notes', label: 'Completion Notes', type: 'textarea', size: 12, required: false },
  ];

  if (includeCompletionImages && [2, 4].includes(newWorkOrder.statusId)) {
    fields.push({
      field: 'completionImages',
      label: 'Completion Images',
      type: 'images',
      size: 12,
      directory: 'workorderimages',
      onImageClick: handleImageClick,
      required: false,
    });
  }

  return fields;
};

export const buildWorkOrderValidationFields = ({
  generalFields,
  completeFields,
  editingId,
  statusId,
}) => {
  const fields = [...generalFields];
  if (editingId && [2, 4].includes(Number(statusId))) {
    fields.push(...completeFields);
  }
  return fields;
};

export const getWorkOrderStatusValidationErrors = ({
  newWorkOrder,
  duration,
  actualDuration,
}) => {
  const validationErrors = {};
  const statusId = Number(newWorkOrder.statusId);
  const now = new Date();
  const parseDate = (value) => {
    if (!value) return null;
    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  };

  const scheduledAt = parseDate(newWorkOrder.scheduledAt);
  const dueDate = parseDate(newWorkOrder.dueDate);
  const startedAt = parseDate(newWorkOrder.startedAt);
  const completedAt = parseDate(newWorkOrder.completedAt);

  const durationNum = parseFloat(duration);
  if (duration && (Number.isNaN(durationNum) || durationNum < 0 || durationNum > 9999)) {
    validationErrors.duration = 'Duration must be between 0 and 9999 hours';
  }

  if (statusId === 4) {
    const actualNum = parseFloat(actualDuration);
    if (actualDuration && (Number.isNaN(actualNum) || actualNum < 0 || actualNum > 9999)) {
      validationErrors.actualDuration = 'Actual duration must be between 0 and 9999 hours';
    }
  }

  if (statusId === 1) {
    if (!scheduledAt) {
      validationErrors.scheduledAt = 'Scheduled start is required for open work orders';
    }
    if (!dueDate) {
      validationErrors.dueDate = 'Due date is required for open work orders';
    } else if (scheduledAt && dueDate <= scheduledAt) {
      validationErrors.dueDate = 'Due date must be after scheduled start for open work orders';
    }
  } else if (statusId === 2) {
    if (!startedAt) {
      validationErrors.startedAt = 'Started time is required for in-progress work orders';
    } else if (startedAt >= now) {
      validationErrors.startedAt = 'Started time must be in the past for in-progress work orders';
    }
    if (!dueDate) {
      validationErrors.dueDate = 'Estimated completion is required for in-progress work orders';
    } else if (startedAt && dueDate <= startedAt) {
      validationErrors.dueDate = 'Estimated completion must be after started time for in-progress work orders';
    }
  } else if (statusId === 4) {
    if (!startedAt) {
      validationErrors.startedAt = 'Started time is required for completed work orders';
    } else if (startedAt >= now) {
      validationErrors.startedAt = 'Started time must be in the past for completed work orders';
    }

    if (!completedAt) {
      validationErrors.completedAt = 'Completed time is required for completed work orders';
    } else {
      if (completedAt >= now) {
        validationErrors.completedAt = 'Completed time must be in the past for completed work orders';
      }
      if (startedAt && completedAt <= startedAt) {
        validationErrors.completedAt = 'Completed time must be after started time for completed work orders';
      }
    }
  } else if (statusId === 5) {
    if (!scheduledAt) {
      validationErrors.scheduledAt = 'Scheduled start is required for cancelled work orders';
    } else if (scheduledAt <= now) {
      validationErrors.scheduledAt = 'Scheduled start must be in the future for cancelled work orders';
    }
    if (!dueDate) {
      validationErrors.dueDate = 'Due date is required for cancelled work orders';
    } else if (scheduledAt && dueDate <= scheduledAt) {
      validationErrors.dueDate = 'Due date must be after scheduled start for cancelled work orders';
    }
  }

  return validationErrors;
};
